import { X } from 'lucide-react';
import { useRef } from 'react';
import { useClickOutside } from '@/utils';
import "./ConfirmRestore.scss";

type Props = {
    type: "Invoice" | "Customer";
    id?: string;
    count?: number;
    onClose: () => void;
    onRestore: () => void;
}
export const ConfirmRestore = ({ type, count, id, onClose, onRestore }: Props) => {
    const areaRef = useRef<HTMLDivElement>(null);
    useClickOutside(areaRef, onClose);

    return <div className="restore" ref={areaRef}>
        <button className="restore__close" onClick={onClose}>
            <X width={18} height={18} />
        </button>

        {count ? <h2>Restore {type}s</h2> : <h2>Restore {type}</h2>}
        <div className="delete__container">
            {(!count) ?
                <p> Are you sure you want to restore {type.toLowerCase()} {id}?</p> :
                <p> Are you sure you want to restore {count} {type.toLowerCase()}s?</p>}
        </div>
        <div className="restore__buttons">
            <button className="restore__cancel" onClick={onClose}>Cancel</button>
            <button className="restore__confirm" onClick={async () => {
                await onRestore();
                onClose();
            }}>
                Restore
            </button>
        </div>
    </div>
}